// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@locus-taxy/neo-ui';

const LoadingMessage = (): React.Node => {
    const { t } = useTranslation('platform');

    return (
        <Box px={4} py={2} color="black">
            <Text size="regular">{t('settings.messages.loading')}...</Text>
        </Box>
    );
};

export default LoadingMessage;
